/**
 * API base URL.
 *
 * - On the Next.js server (SSR / route handlers), prefer `INTERNAL_API_URL`
 *   when set. In Docker production the website container can't reach
 *   `https://hamishon.com/api` reliably (no internet on the internal
 *   network, plus hairpin NAT + SSL issues), so SSR fetches must go
 *   directly to the backend container via Docker DNS, e.g.
 *   `http://backend:3001/api`.
 * - On the client outside localhost, always use the current origin so the
 *   browser never hits a stale build-time URL.
 */
export function getApiUrl(): string {
  if (typeof window === 'undefined') {
    if (process.env.INTERNAL_API_URL) {
      return process.env.INTERNAL_API_URL
    }
    // In production (Docker) the public URL baked into NEXT_PUBLIC_API_URL is
    // unreachable from inside the website container's internal network. Fall
    // back to the conventional Docker DNS name so SSR works even when
    // INTERNAL_API_URL was not propagated to the container.
    if (process.env.NODE_ENV === 'production') {
      return process.env.NEXT_PUBLIC_BACKEND_INTERNAL_URL || 'http://backend:3001/api'
    }
    return process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000/api'
  }

  if (
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
  ) {
    return `${window.location.origin}/api`
  }

  return process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000/api'
}
